export enum ColumnFilterType {
  Text = "text",
  Select = "select",
  Date = "date",
  Year = "year",
}
